import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Tabs from '@/components/Tabs'
import EmailForm from './EmailForm'
import LinkForm from './LinkForm'

import type { RelatedUsersList } from '@/types/components/Modal/Templates/ShareCollection'

interface TabsViewProps {
  onShare: (users: RelatedUsersList) => Promise<boolean>
  allUsers: RelatedUsersList
  config: {
    collectionId: string
    setAction: (action: boolean) => void
    action: boolean
    loading?: boolean
    setLoading: (loading: boolean) => void
  }
  accessList: RelatedUsersList
  onShowManagementView: () => void
  onCancel: () => void
  shareLink?: string
  defaultActiveTabIndex?: number
}

export default function TabsView({
  onShare,
  allUsers,
  config,
  accessList,
  onShowManagementView,
  onCancel,
  shareLink,
  defaultActiveTabIndex
}: TabsViewProps) {
  const { t } = useTranslation()

  const [isShowingTabSelector, setIsShowingTabSelector] = useState(true)

  const changeTabSelectorVisibility = useCallback(() => {
    setIsShowingTabSelector(!isShowingTabSelector)
  }, [isShowingTabSelector])

  return (
    <>
      <Tabs
        defaultActiveTabIndex={defaultActiveTabIndex}
        isShowingTabSelector={isShowingTabSelector}
        tabs={[
          {
            key: 'email',
            icon: 'mail',
            iconClass: 'material-icons-outlined',
            title: t('buttons.emailTab'),
            content: (
              <EmailForm
                onShare={onShare}
                allUsers={allUsers}
                accessList={accessList}
                onShowManagementView={onShowManagementView}
                onCancel={onCancel}
                isShowingTabSelector={isShowingTabSelector}
                changeTabSelectorVisibility={changeTabSelectorVisibility}
              />
            )
          },
          {
            key: 'link',
            icon: 'link',
            iconClass: 'material-icons',
            title: t('buttons.linkTab'),
            content: (
              <LinkForm
                accessList={accessList}
                onShowManagementView={onShowManagementView}
                shareLink={shareLink}
                isLoading={config.loading}
              />
            )
          }
        ]}
      />
    </>
  )
}
